var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('multi-search', {
    attrs: {
      "fields": _vm.multiFields,
      "mode": "cover"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "姓名",
      "show-overflow-tooltip": "",
      "align": "center",
      "fixed": "",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.resumeForm.name))]
      }
    }], null, false, 2733853115)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "岗位",
      "class-name": "no-wrap",
      "align": "center",
      "fixed": "",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.oldPositionName || scope.row.newPositionName) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": _vm.getPositionTipText(scope.row),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-xinxi"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": scope.row.positionForm.name
          }
        }, [_vm._v(_vm._s(scope.row.positionForm.name))])]
      }
    }], null, false, 455889647)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proName",
      "label": "所属项目",
      "show-overflow-tooltip": "",
      "align": "center",
      "fixed": "",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.gender",
      "label": "性别",
      "show-overflow-tooltip": "",
      "align": "center",
      "min-width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s({
          1: '男',
          2: '女'
        }[scope.row.resumeForm.gender] || '-'))]
      }
    }], null, false, 3168019877)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.mobilePhone",
      "label": "手机",
      "show-overflow-tooltip": "",
      "align": "center",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.email",
      "label": "邮箱",
      "show-overflow-tooltip": "",
      "align": "center",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最高学历",
      "align": "center",
      "show-overflow-tooltip": "",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.getSelectMapText('WB_EDU_DEGREE', scope.row.resumeForm.resumeMaxEducation.degree)) + "\n              ")]
      }
    }], null, false, 2196099462)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最高学历学校",
      "align": "center",
      "show-overflow-tooltip": "",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.resumeForm.schoolType === '1') ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("985")]) : (scope.row.resumeForm.schoolType === '2') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("211")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(scope.row.resumeForm.resumeMaxEducation.school) + "\n\t\t\t\t\t\t\t")]
      }
    }], null, false, 904880564)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.resumeMaxEducation.major",
      "label": "专业",
      "show-overflow-tooltip": "",
      "align": "center",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "positionForm.mark",
      "label": "招聘HR",
      "show-overflow-tooltip": "",
      "align": "center",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "应聘城市",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.getSelectMapText('WB_POSITION_CITY', scope.row.resumeForm.expectCityId)))]
      }
    }], null, false, 2191189520)
  }), _vm._v(" "), (!_vm.isSchool) ? _c('el-table-column', {
    attrs: {
      "label": "游戏经验",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.resumeForm.gameExperience))]
      }
    }], null, false, 4049949644)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历附件",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('attach-view-in-list', {
          attrs: {
            "attachList": scope.row.resumeForm.resumeAttachList
          }
        })]
      }
    }], null, false, 2021903071)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "投递时间",
      "show-overflow-tooltip": "",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.dateFormat(scope.row.commitTime)))]
      }
    }], null, false, 3274253775)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.operateReason) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": scope.row.operateReason,
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-xinxi"
          }
        }, [_vm._v(_vm._s(_vm.getStatusText(scope.row)))])], 1) : _c('span', [_vm._v(_vm._s(_vm.getStatusText(scope.row)))])]
      }
    }], null, false, 613067865)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.remark",
      "show-overflow-tooltip": "",
      "label": "备注",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.remark",
      "show-overflow-tooltip": "",
      "label": "最近操作人",
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_c('p', [_vm._v(_vm._s(scope.row.lastOperateUserInfo ? scope.row.lastOperateUserInfo.name : ''))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.lastOperateTime && scope.row.lastOperateTime.slice(5)))])])]
      }
    }], null, false, 4062077065)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mb-20 mt-10",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "page-sizes": [20, 50, 100, 200],
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03f5d98e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDuplication/index.vue
// module id = null
// module chunks = 